"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Parcel_1 = __importDefault(require("@common/models/Parcel"));
const BecropReport_1 = __importDefault(require("@common/models/BecropReport"));
const BecropReportShi_1 = __importDefault(require("@common/models/BecropReportShi"));
class Sample {
    constructor(c_muestra_wineseq, name, pending_status, client_reference, c_estado, is_bcplus, parcel, becrop_report, becrop_report_shi, fecha_muestra, createdAt, updatedAt) {
        this.c_muestra_wineseq = c_muestra_wineseq;
        this.name = name;
        this.pending_status = pending_status;
        this.client_reference = client_reference;
        this.c_estado = c_estado;
        this.is_bcplus = is_bcplus;
        this.parcel = parcel;
        this.becrop_report = becrop_report;
        this.becrop_report_shi = becrop_report_shi;
        this.fecha_muestra = fecha_muestra;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
    }
    static fromJson(json) {
        return new Sample(json.c_muestra_wineseq, json.name, json.pending_status, json.client_reference, json.c_estado, json.is_bcplus, json.parcel ? Parcel_1.default.fromJson(json.parcel) : null, json.becrop_report ? BecropReport_1.default.fromJson(json.becrop_report) : null, json.becrop_report_shi ? BecropReportShi_1.default.fromJson(json.becrop_report_shi) : null, json.fecha_muestra, json.createdAt, json.updatedAt);
    }
}
exports.default = Sample;
